import { useContext } from 'react';
import { ProductLikesContext } from '../../providers/ProductLikesProvider';

export default function useInitialData() {
  return useContext(ProductLikesContext);
}
